module.exports = __webpack_public_path__ + "static/media/beef3.f87be5ef.jpg";